import { ActionType } from 'app/store/actionTypes';
import { ActionsUnion, createAction } from 'app/store/helpers';
import { ShouldCheckIfConsentResetRequiredUpdate } from './state.interface';

export const ConsentsActions = {
  setShouldCheckIfConsentResetRequired: (
    value: ShouldCheckIfConsentResetRequiredUpdate
  ) =>
    createAction(ActionType.SET_SHOULD_CHECK_IF_CONSENT_RESET_REQUIRED, value),
};

export type ConsentsActionsType = ActionsUnion<typeof ConsentsActions>;
